import React, { Component } from 'react';
import {
  TextField, Button,
} from '@material-ui/core';
import { I18n } from 'react-redux-i18n';

import themeConfig from '../../theme-config';


class Loading extends Component {

    static propTypes = {

    };

    constructor(props) {

      super(props);


    }


    render() {


      return (


        <div className="loading">

          <div className="loading__logo image spinner">

              <svg className="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle className="path" fill="none" strokeWidth="2" strokeLinecap="round" cx="33" cy="33" r="30" />
              </svg>

          </div>
          <img className="loading__logo" src={themeConfig.logo} alt="logo" />

        </div>


      );

    }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/util/Loading.js